import React from 'react'
import { Link } from 'react-router'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'

export default class extends React.Component {
  componentDidMount() {
  }

  render() {
    return (
      <div className="agreement">
   <h1>User Agreement</h1><br />
I. General Provisions of the User Agreement<br/>
1. This agreement is entered into between the registered user of Yayya (including services provided via the mobile app, hereinafter referred to as the "Operator") and the user (hereinafter referred to as the "User").<br/>
2. Users shall carefully read the terms of this agreement before registration and complete the entire registration process as instructed on the page.<br/>
3. By proceeding to the next step during registration, the user is deemed to have fully understood and completely accepted all terms under this agreement and thus enters into this agreement with the Operator.<br/>
4. The Operator reserves the right to modify or supplement the relevant rules under this agreement from time to time and publish them on the website. Continued use by the user shall be deemed as acceptance of the revised terms.<br/>

II. Instructions for Use of User Services<br/>
1. When registering, the user shall fill in accurate personal information such as username, password, and mobile number as prompted, ensuring completeness, accuracy, and truthfulness.<br/>
2. Once registration is successful, the user becomes a legally registered user of the Operator, will receive a user account for the app, and may set and modify their password at any time. The user is fully responsible for the security of their account and shall bear all legal responsibility for actions and events carried out under their username.<br/>

III. Privacy Protection<br/>
We value your privacy. Your personal information will be protected and governed in accordance with the Privacy Policy. For details, please refer to the Privacy Policy.<br/>

IV. Other Provisions<br/>
4.1 The headings of all clauses in this agreement are provided for reading convenience only and carry no actual meaning. They shall not be used as a basis for interpreting the agreement.<br/>
4.2 If any clause of this agreement is deemed invalid or unenforceable for any reason, the remaining clauses shall remain valid and binding on both parties.<br/>
   </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/teamsofservice/index.js